export const ReceiptTypes = {
  REGULAR: 1,
  RETURN: 2,
  labels: {
    1: 'Продажа',
    2: 'Возврат',
  },
};

export const RECEIPT_TYPE_OPTIONS = [
  { id: ReceiptTypes.REGULAR, label: ReceiptTypes.labels[1] },
  { id: ReceiptTypes.RETURN, label: ReceiptTypes.labels[2] },
];
